export default __webpack_public_path__ + "static/media/3115.c97cb647.jpg";